/**
 * Alhup Map — Intercepta "Comprar ahora" y redirige a /pages/confirmar-pedido
 * (Toda la UX de mapa + WhatsApp + confirmación está en la página unificada)
 */
(function(){
'use strict';

function isProductPage(){return /\/products\//.test(window.location.pathname);}

function interceptBuyNow(){
  if(!isProductPage())return;
  // Ocultar el picker viejo si existe (ya no se usa en producto, todo va en la página unificada)
  var picker=document.getElementById('alhup-location-picker');
  if(picker)picker.style.display='none';

  var sels='.shopify-payment-button button,.shopify-payment-button__button,'+
    '[data-shopify="payment-button"] button,button[name="checkout"],'+
    '.dynamic-checkout__content button,.product-form__cart-submit--buy-now';
  var btns=document.querySelectorAll(sels);
  btns.forEach(function(btn){
    if(btn.dataset.alhupIntercepted)return;
    btn.dataset.alhupIntercepted='1';
    btn.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
      var form=document.querySelector('form[action*="/cart/add"]');
      var variantInput=form?form.querySelector('[name="id"],input[name="id"],select[name="id"]'):null;
      var variantId=variantInput?variantInput.value:null;
      if(!variantId){window.location.href='/pages/confirmar-pedido';return;}
      var qtyInput=form?form.querySelector('[name="quantity"]'):null;
      var qty=qtyInput?parseInt(qtyInput.value)||1:1;
      // Limpiar carrito, agregar producto, redirigir a página unificada
      fetch('/cart/clear.js',{method:'POST'}).then(function(){
        return fetch('/cart/add.js',{
          method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(variantId),quantity:qty}]})
        });
      }).then(function(){
        window.location.href='/pages/confirmar-pedido';
      }).catch(function(){
        window.location.href='/pages/confirmar-pedido';
      });
      return false;
    },true);
  });

  // También interceptar "Agregar al carrito" para redirigir a la misma página
  var addBtns=document.querySelectorAll('[name="add"],button[type="submit"][data-add-to-cart],.btn--add-to-cart,.product__submit');
  addBtns.forEach(function(btn){
    if(btn.dataset.alhupIntercepted)return;
    btn.dataset.alhupIntercepted='1';
    btn.addEventListener('click',function(e){
      // Dejar que el form se envíe normalmente al carrito, luego redirigir
      setTimeout(function(){window.location.href='/pages/confirmar-pedido';},800);
    });
  });
}

document.addEventListener('DOMContentLoaded',function(){
  setTimeout(interceptBuyNow,800);
  setTimeout(interceptBuyNow,2500);
});

})();
